import { AxiosSource, getHallData } from '@/api'
import { DeskData } from '@/datamodel/deskdata'
import { ResponseData } from '@/datamodel/response-data'
import { MultipleDeskParams } from '@/datamodel/urlparams/MultipleDeskParams'
import router, { ROUTES } from '@/router'
import { store } from '@/store'
import { LobyMutation } from '@/store/module/loby'
import { UserMutation } from '@/store/module/user'
import { EventBuss, SOCKET_MESSAGE } from '@/utils/constants'
import axios from 'axios'
import { RedPacket, SocketMessage, Table, UserInfo } from 'vue'
import { Options, Vue } from 'vue-class-component'
import { useI18n } from 'vue-i18n'
import { Action, Getter } from 'vuex-class'

@Options({})
export class LobyMixin extends Vue {
    selectedTab = 'G005'
    hasPendingRequest = false
    selectedIndex = -1
    showPasswordForm = false
    showPasswordRequired = false
    showHistory = false
    showSettings = false
    showRule = false
    iN = useI18n().t
    $router!: Vue['$router']
    emitter!: Vue['emitter']

    showPacket = false
    showPacket2 = false
    packet2s: RedPacket[] = []

    failureCounter = 0

    serviceTimer: number | boolean = false

    desks: Array<DeskData> = new Array<DeskData>()
    tables: Array<Table> = []
    //#region Vuex
    @Getter('memberId') memberId!: number
    @Getter('lobyNotice') notice!: string
    @Getter('sessionId') sessionId!: string
    @Getter('lobyInfoKey') infoKey!: number
    @Getter('userId') userId!: string
    @Getter('token') token!: string
    @Getter('showRedPackets') showRedPackets!: boolean

    @Getter('userInfo') userInfo!: UserInfo

    @Action('getMultipleDesk') getMultipleDesk!: (
        model: MultipleDeskParams
    ) => Promise<ResponseData>
    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void
    @Action('destroySession') destroySession!: () => void
    //#endregion

    //#region Vue Methods
    mounted(): void {
        // this.fetchData()
        this.loadData()

        if (this.userInfo.firstLogin === 0) this.showPasswordRequired = true
    }

    beforeMount(): void {
        this.emitter.on(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
        this.emitter.on(EventBuss.PAGE_ON_VISIBLE, this.onPageVisible)
        this.emitter.on(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )
    }

    beforeUnmount(): void {
        this.endService()
        this.emitter.off(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
        this.emitter.off(EventBuss.PAGE_ON_VISIBLE, this.onPageVisible)
        this.emitter.off(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )
    }

    //#endregion

    //#region Helpers

    onPageVisible(): void {
        this.loadData(true)
    }

    onPacket2Close(): void {
        this.showPacket2 = false
        this.packet2s = []
    }
    handleReconnectSuccess(): void {
        console.log('SOCKET RECONNECTED')
        this.loadData(true)
    }

    loadData(_forceReload = false): void {
        if (!_forceReload) this.showLoading()
        let _params: any = {}

        let _gType = ''

        if (this.selectedTab === 'G005') _gType = ''
        else _gType = this.selectedTab

        _params = {
            token: this.token,
            gameTypeNo: _gType
        }

        getHallData(_params)
            .then(r => {
                this.failureCounter = 0
                if (!_forceReload) this.hideLoading()
                const response = r.data
                const { status } = response
                if (status === 200) {
                    // handle data
                    this.tables = response.data.gameTableList

                    if (response.data.memberLimitList) {
                        store.commit(
                            UserMutation.SET_USER_INFO_LIMITS,
                            response.data.memberLimitList
                        )
                    }

                    if (response.data.noticeList.length > 0) {
                        // save loby notice
                        let noticeContent = ''
                        response.data.noticeList.forEach((x, index) => {
                            let sufix = ''
                            if (index > 0) sufix = ', '
                            noticeContent += `${sufix}${x.content}`
                        })
                        store.commit(
                            LobyMutation.SET_LOBY_NOTICE,
                            noticeContent
                        )
                    }

                    if (response.data.systemRedPacketLogList.length > 0) {
                        store.commit(
                            UserMutation.SET_RED_PACKETS,
                            response.data.systemRedPacketLogList
                        )

                        // console.log(this.showRedPackets)

                        if (this.showRedPackets) {
                            this.showPacket = true
                            // console.log('show RedPackets')
                        }
                    }

                    if (response.data.memberAmount) {
                        store.commit(
                            UserMutation.SET_BET_COIN,
                            response.data.memberAmount
                        )
                    }
                } else if (status === 301) {
                    // session is expired
                    this.endService()
                    this.emitter.emit(EventBuss.SESSION_EXPIRED)
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    this.failureCounter++

                    if (!_forceReload) {
                        this.hideLoading()
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )
                    }
                    if (this.failureCounter > 3) {
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )

                        this.emitter.emit(EventBuss.SOCKET_CLOSE)
                        store.commit(UserMutation.DELETE_SESSION)
                        router.push({ name: ROUTES.LOGIN })
                        return
                    }

                    this.serviceTimer = setTimeout(() => {
                        this.loadData(true)
                    }, 3000)
                }
            })
    }

    endService(): void {
        if (AxiosSource) {
            AxiosSource.Source.cancel()
            AxiosSource.Source = axios.CancelToken.source()
        }

        if (typeof this.serviceTimer === 'number') {
            clearInterval(this.serviceTimer)
            this.serviceTimer = false
        }
    }

    selectItem(deskId: number): void {
        if (this.selectedIndex === deskId) {
            this.selectedIndex = -1
            return
        }

        this.selectedIndex = deskId
    }
    //#endregion

    //#region Click Events
    onSelectTab(index: string): void {
        if (this.selectedTab !== index) {
            this.selectedTab = index

            this.endService()
            this.loadData()
        }
    }

    enterMultiTable(): void {
        // console.log('OPS')
        router.push({
            name: ROUTES.MULTI_TABLE
        })
    }

    enterTable(desk: Table) {
        router.push({
            name: ROUTES.GAME,
            query: {
                desk: desk.id,
                gameType: desk.gameTypeNo
            }
        })
    }
    //#endregion

    //#region WS Message
    handlesSocketMessages(_message: SocketMessage | any) {
        const { type } = _message
        const _type = type.toUpperCase()

        if (
            _type === SOCKET_MESSAGE.NEW_GAME ||
            _type === SOCKET_MESSAGE.END_GAME ||
            _type === SOCKET_MESSAGE.STOP_GAME
        ) {
            // console.log(_type)
            const _table = (_message as SocketMessage).gameTable

            if (_table) {
                // if (
                //     _type === SOCKET_MESSAGE.NEW_GAME &&
                //     _table.gameTypeNo === 'G002' &&
                //     _table.tableNo !== '1' &&
                //     _table.tableNo !== '2'
                // ) {
                //     console.log(
                //         _table.tableNo,
                //         'started countdown at:',
                //         _table.expand.daoJiShiBetTime
                //     )
                // }

                const _desk = this.tables.find(_d => _d.id === _table.id)

                if (_desk && _type !== SOCKET_MESSAGE.CANCEL_GAME) {
                    const _index = this.tables.indexOf(_desk)
                    if (_index !== -1) this.tables[_index] = _table
                }
            }
        } else if (_type === SOCKET_MESSAGE.NEW_SHOE) {
            const _table = (_message as SocketMessage).gameTable

            if (_table) {
                const _desk = this.tables.find(_d => _d.id === _table.id)
                if (_desk && _type !== SOCKET_MESSAGE.CANCEL_GAME) {
                    const _index = this.tables.indexOf(_desk)
                    if (_index !== -1) this.tables[_index] = _table
                }
            }
        } else if (_type === SOCKET_MESSAGE.RED) {
            if (_message.userId === this.memberId) {
                const _r: RedPacket = {
                    id: -1,
                    redId: -1,
                    amount: _message.amount,
                    remark: _message.remark,
                    userId: _message.userId,
                    userType: -1,
                    userCode: _message.userCode,
                    status: -1,
                    opsTime: '',
                    endTime: _message.endTime,
                    receiveStatus: -1
                }

                this.packet2s.push(_r)
                this.showPacket2 = true
            }
        }
    }

    //#region Computed Properties
    get listData(): Array<DeskData> {
        return this.desks
    }
    //#endregion
}
